import React from 'react';
import { CheckCircle, Error, Info, Warning } from '@mui/icons-material';
import { Box, Typography } from '@mui/material';
import { useSnackbar } from 'notistack';

const NotifContext = React.createContext();

const NotifProvider = props => {
  const variantIcons = {
    success: <CheckCircle style={{ marginRight: 8 }} />,
    error: <Error style={{ marginRight: 8 }} />,
    warning: <Warning style={{ marginRight: 8 }} />,
    info: <Info style={{ marginRight: 8 }} />
  };

  const variantColor = {
    success: '#28A745',
    error: '#BD3E48',
    warning: 'black',
    info: 'black'
  };

  const { enqueueSnackbar } = useSnackbar();
  const notify = ({ message, variant, time = 4000 }) => {
    return enqueueSnackbar(message, {
      variant,
      autoHideDuration: time,
      content: key => (
        <Box
          key={key}
          sx={{
            display: 'flex',
            alignItems: 'center',
            backgroundColor: 'white',
            color: variantColor[variant] ?? 'black',
            minHeight: 40,
            width: 400,
            borderRadius: 4,
            padding: '8px 16px',
            boxShadow: 1
          }}
        >
          {variantIcons[variant]}
          <Typography>{message}</Typography>
        </Box>
      )
    });
  };
  const value = {
    notify
  };

  return <NotifContext.Provider {...props} value={value} />;
};

export const useNotif = () => {
  const context = React.useContext(NotifContext);
  if (!context)
    throw new Error('NotifContext must be called in Notif Provider');
  return context;
};

export default NotifProvider;
